import {
  OrganisationResponseV1,
  OrganisationStatusEnum,
  ProductListResponseV1,
  OrganisationProductResponseV1,
  OrganisationListResponseV1,
} from "@ucchub/ui/src/apiTypes/organisation";

export type CustomerDetails = Pick<
  OrganisationResponseV1,
  | "id"
  | "addressLine1"
  | "addressLine2"
  | "area"
  | "city"
  | "contactEmail"
  | "contactFirstName"
  | "contactLastName"
  | "country"
  | "name"
  | "status"
  | "postcode"
  | "phoneNumber"
  | "pid"
>;

export type CustomerListItem = OrganisationListResponseV1;

export type CustomerProduct = OrganisationProductResponseV1;

export const OrganisationStatus = OrganisationStatusEnum;

export type Product = ProductListResponseV1;
